<template>
  <div class="individual-contact-container">
    <Loader v-if="!currentUser || loading" />
    <div v-if="currentUser && !loading" class="contact-content-wrapper">
      <div class="page-content contact-page-content">
        <div class="ibox contact-ibox">
          <div class="ibox-body contact-ibox-body">
            <div class="row justify-content-center no-gutters contact-row">
              <div class="col-sm-6 profile-block contact-profile-block">
                <div class="profile-wrapper">
                  <Profile
                    :key="applicantId"
                    :applicant-id="applicantId"
                    :fromContact="true"
                    :hide-header-right="false"
                    :hideMailIcon="true"
                    :isReviewer="isReviewer"
                    :isPreview="false"
                    :hideDownloadPdf="true"
                    :isMaxHeight="true"
                    :showNavigation="showNavigation"
                    :canGoPrevious="canGoPrevious"
                    :canGoNext="canGoNext"
                    @previous="handlePrevious"
                    @next="handleNext"
                  />
                </div>
              </div>
              <div class="col-sm-6 message-block contact-message-block">
                <div class="contact-header-fixed d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    class="close"
                    @click="hideModal"
                    aria-label="Close"
                    style="font-size: 28px; font-weight: 300; opacity: 0.5;"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="scout-section-container">
                  <ScoutJobSection />
                  <!-- <ScoutTypeSection /> -->
                </div>
                <div class="message-area-container">
                  <div
                    v-if="messageByJobseeker.length === 0"
                    class="empty-message-box"
                  >
                    <p class="empty-message-text">メッセージはありません</p>
                  </div>
                  <MessageList
                    :messages="messagesByJobseeker"
                    @messageToggled="handleMessageToggled"
                  />
                  <MessageCompose
                    ref="messageComposeRef"
                    v-if="
                      messageByJobseeker.length == 0 ||
                        openMessageComposeForm == true ||
                        is_draft
                    "
                    :draftMessage="draftMessage"
                    :company="company"
                    :applicant="applicant"
                    :applicantJD="applicantJd"
                    :sentDate="sentDate"
                    :previewEmailBody="previewEmailBody"
                    :isSubmitting="isSubmitting"
                    :isFirstMessage="isFirstMessage"
                    @onSubmit="onSubmit"
                    @onDraft="onDraft"
                    @cancel="cancel"
                  />
                </div>
                <div class="message-bottom-fixed">
                  <div
                    class="message-button-container mt-1 p-2"
                    v-if="!openMessageComposeForm"
                  >
                    <button class="btn message-button" @click="openMessageForm()">
                      再度連絡する
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from '../applicants/profile/Profile.vue';
import Loader from '@/components/utils/Loader.vue';
import MessageCompose from './MessageCompose.vue';
import MessageList from './MessageList.vue';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import ApiService from '../../../service/apiService';
import Api from '../../../config/api';
import ScoutJobSection from './ScoutJobSection.vue';
import ScoutTypeSection from './ScoutTypeSection.vue';
import contactNavigation from '../../../utils/mixins/contactNavigation';
import contactMessageHandling from '../../../utils/mixins/contactMessageHandling';
import moment from 'moment';

export default {
  name: 'IndividualContact',
  props: {
    applicant_id: String,
    showIndividualContact: Boolean,
    applicantIndex: Number,
    email: String,
    showNavigation: {
      type: Boolean,
      default: false,
    },
    contactListType: {
      type: String,
      default: null, // 'sent' or 'received' or null (auto-detect from route)
    },
  },
  components: {
    Profile,
    Loader,
    MessageCompose,
    MessageList,
    ScoutJobSection,
    ScoutTypeSection,
  },
  mixins: [contactNavigation, contactMessageHandling],
  data() {
    return {
      applicantId: this.applicant_id,
      applicantJd: null,
      previewEmailBody: '',
      fetchedApplicant: null,
      messageByJobseeker: [],
      openMessageComposeForm: true,
      showReplyForm: false,
      is_draft: false,
      draftMessage: {},
      isSubmitting: false,
      loading: false,
      selectedMessageId: null,
      index: this.applicantIndex,
      // applicant: null,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      applicantsCount: 'getApplicantCounts',
      currentPage: 'getPage',
      getFirstProfileModalOpen: 'getFirstProfileModalOpen',
      getLastProfileModalOpen: 'getLastProfileModalOpen',
    }),
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      applicant: ({ applicant }) => applicant.profile,
      currentPageApplicants: ({ applicant }) => applicant.currentPageApplicants,
      currentApplicantJd: ({ applicant }) => applicant.applicantJD,
      receivedContacts: ({ individual_contact }) => individual_contact.receivedContacts,
      sentContacts: ({ individual_contact }) => individual_contact.sentContacts,
    }),
    rowNumber() {
      return this.index + 1 + (this.currentPage - 1) * 15;
    },
    company() {
      // console.log(this.currentUser);
      return this.currentUser.companyName;
    },
    hasIndividualContactAuthority() {
      return (
        this.currentUser &&
        this.currentUser.companyContactAuthority
      );
    },
    sentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // Note that months are zero-based, so we add 1.
      const day = currentDate.getDate();
      const formattedDate = `${year}年${month}月${day}日`;
      return formattedDate;
    },
    isReviewer() {
      return this.currentUser.isCreateReviewUser;
    },
    messagesByJobseeker() {
      return this.messageByJobseeker.filter((msg) => {
        return msg.is_draft !== true;
      });
    },
    isFirstMessage() {
      return this.messageByJobseeker.length || 0;
    },
  },
  methods: {
    ...mapMutations({
      setPage: 'setPage',
      setReloadApplicants: 'setReloadApplicants',
      removeApplicantFromTempList: 'removeApplicantFromTempList',
      setProfile: 'setProfile',
      setApplicantJd: 'setApplicantJd',
    }),
    ...mapActions(['addFlashMessages']),
    handleMessageToggled(item) {
      this.selectedMessageId = item.detailsVisible ? item._id : null;
    },
    formatDate(date) {
      return date ? moment(date).format('YYYY/MM/DD') : '';
    },
    trimContent(content) {
      if (!content) return '';
      // First trim the entire content
      content = content.trim();
      // Then handle each line, preserving intentional line breaks
      const result = content
        .split('\n')
        .map((line) => {
          // Remove multiple spaces between words but keep single spaces
          return line.replace(/\s+/g, ' ').trim();
        })
        .join('\n');
      return result;
    },
    confirmMessage() {
      this.$refs.messageComposeRef.processMessage();
    },
    openMessageForm() {
      this.openMessageComposeForm = true;
      this.$nextTick(() => {
        const el = this.$el.querySelector('.message-area-container');
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
    hideModal() {
      // No modal ref here – when inside IndividualContactModal, parent closes via @close
      this.$emit('close');
      if (this.currentPageApplicants.length !== this.applicants.length) {
        this.setReloadApplicants(true);
      }
    },
    cancel() {
      this.openMessageComposeForm = false;
    },
    async loadApplicantData(applicantIdParam = null) {
      // Use the passed parameter, or current applicantId, or fall back to prop
      const applicantIdToLoad = applicantIdParam || this.applicantId || this.applicant_id || this.$route.params.applicantId;
      
      // Update applicantId if we have a new value
      if (applicantIdToLoad && applicantIdToLoad !== this.applicantId) {
        this.applicantId = applicantIdToLoad;
      }
      
      // Find the index in the navigation list if not already set
      if (this.navigationList.length > 0 && (this.index === undefined || this.index === null)) {
        const foundIndex = this.navigationList.findIndex(
          applicant => {
            const applicantId = applicant._id || applicant.id;
            return applicantId === this.applicantId;
          }
        );
        if (foundIndex !== -1) {
          this.index = foundIndex;
        }
      }
      
      await this.findMessageByJobseeker();
      this.findDraftMessage();
      try {
        let res = await ApiService.get(
          Api.endpoints.APPLICANT_PROFILE(this.applicantId)
        );
        const { applicant, applicantJd } = res.data.data;
        this.setProfile(applicant);
        this.setApplicantJd(applicantJd);
        this.applicantJd = applicantJd;
      } catch (err) {
        if (err && err.response && err.response.status == 502) {
          this.addFlashMessages([
            {
              message: `${err.response.data.data.error_description}`,
              type: 'danger',
            },
          ]);
          this.loader = false;
          this.errors = [];
          this.parseErrorResponse(err.response);
          this.loader = false;
          window.scrollTo(0, 0);
        }
      }
    },
  },
  mounted() {
    this.changeBodyBackground();
    // if (this.currentUser && !this.hasIndividualContactAuthority) {
    //   // this.$router.push('/applicant');
    // }
  },
  watch: {
    hasIndividualContactAuthority(newValue, oldValue) {
      if (!newValue) {
        // Navigate to a certain route when hasIndividualContactAuthority is false
        this.$router.push('/applicant');
      }
    },
    showIndividualContact(value) {
      this.showIndividualContact = value;
    },
    navigationList: {
      handler() {
        // Update index when navigation list changes
        this.updateIndexFromApplicantId();
      },
      immediate: true,
    },
    applicant_id(newId) {
      // Update when prop changes
      if (newId && newId !== this.applicantId) {
        this.applicantId = newId;
        this.updateIndexFromApplicantId();
      }
    },
  },
  async created() {
    // Find initial index in navigation list first
    this.updateIndexFromApplicantId();
    await this.loadApplicantData();
  },
  beforeDestroy() {
    this.selectedMessageId = false;
    this.$emit('cancel');
  },
};
</script>

<style scoped>
.individual-contact-container {
  height: 85vh;
  display: flex;
  flex-direction: column;
}

.contact-header-fixed {
  padding: 10px 15px;
  background-color: #F7FFF4;
  min-height: 73px;
  flex-shrink: 0;
}

.contact-content-wrapper {
  flex: 1;
  overflow: hidden;
}

.contact-page-content {
  background: #fff !important;
  height: 100%;
}

.contact-ibox {
  height: 100%;
}

.contact-ibox-body {
  height: 100%;
}

.contact-row {
  height: 100%;
}


.profile-wrapper {
  /* margin-right: 0.5rem;
  padding: 0.25rem; */
  height: 100%;
  overflow: hidden auto;
}

.contact-message-block {
  height: 85vh;
  background: #fff;
  padding-right: 12px;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
}

.contact-profile-block {
  padding-right: 0px;
  /* padding-left: 0px; */
}

.scout-section-container {
  background: #fff;
}

.message-area-container {
  background: #EBEFF1;
  padding: 10px;
  flex: 1;
  min-height: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #888 #d8dde2;
}

.message-bottom-fixed {
  flex-shrink: 0;
  background: #fff;
}

.empty-message-box {
  width: 100%;
  height: 59px;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.empty-message-text {
  margin: 0;
  font-size: 14px;
  color: #000000;
  text-align: center;
  font-weight: bold;
}

.message-button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.message-button {
  background: #036ac9;
  border-radius: 30px;
  width: 200px;
  height: 61px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border: none;
  cursor: pointer;
}

.message-button:hover {
  background: #025a9e;
}
.message-detail-container {
  margin-top: 10px;
  padding: 8px;
  background-color: #fff;
}
.detail {
  text-align: left !important;
  margin-left: 5px;
  word-wrap: break-word;
  max-width: 200px;
  white-space: pre-line;
}
td {
  border: 2px solid #e6e6e6;
  background-color: #fff;
  text-align: left;
  padding: 5px;
  font-size: 14px;
  width: 300px;
  background-color: #e6e6e6;
  color: #617776;
}
:deep(.modal-footer) {
  justify-content: space-between;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  background: #fff;
}

:deep(.modal-xl) {
  max-width: 90vw !important;
}

:deep(.modal-body) {
  padding: 0px !important;
  overflow: hidden;
}

:deep(.modal-content) {
  height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

:deep(.modal-dialog) {
  height: 100%;
  margin: 1.75rem auto;
}

.btn-cancel {
  border-color: #3c3c3c;
  color: #3c3c3c;
  border-radius: 4px;
}

th {
  text-align: center;
}

.profile-block {
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}

.new-submit-button {
  margin-left: 180px;
}

.contact-reply-btn {
  min-width: 115px;
  width: 115px;
  height: 33px;
  padding: 0px;
  font-size: 14px !important;
}

.openForm {
  min-width: 115px;
  width: 115px;
  height: 33px;
  padding: 0px;
  font-size: 14px !important;
  background: #fff !important;
  color: #3c3c3c;
  border: 1px solid #3c3c3c;
  border-radius: 3px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.message-label {
  color: #617776;
  width: 80px;
  min-width: 60px;
  max-width: 120px;
  white-space: nowrap;
  text-align: left;
  background-color: #e6e6e6;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
}

.message-content {
  min-width: 500px;
  font-size: 14px;
  background-color: #e6e6e6;
  padding: 5px;
  white-space: pre-wrap;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: break-word;
}

</style>

<style>
.message-area-container::-webkit-scrollbar {
  width: 8px !important;
  display: block !important;
}
.message-area-container::-webkit-scrollbar-track {
  background: #d0d4d8;
}
.message-area-container::-webkit-scrollbar-thumb {
  background-color: #666;
  border-radius: 4px;
}
</style>
